var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 18.3334C14.6024 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6024 1.66675 10 1.66675C5.39763 1.66675 1.66667 5.39771 1.66667 10.0001C1.66667 14.6025 5.39763 18.3334 10 18.3334Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4584C10.3417 11.4584 10.625 11.1751 10.625 10.8334V6.66675C10.625 6.32508 10.3417 6.04175 10 6.04175C9.65833 6.04175 9.375 6.32508 9.375 6.66675V10.8334C9.375 11.1751 9.65833 11.4584 10 11.4584Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7667 13.0167C10.725 12.9167 10.6667 12.825 10.5917 12.7417C10.5083 12.6667 10.4167 12.6083 10.3167 12.5667C10.1167 12.4833 9.88334 12.4833 9.68334 12.5667C9.58334 12.6083 9.49167 12.6667 9.40834 12.7417C9.33334 12.825 9.27501 12.9167 9.23334 13.0167C9.19167 13.1167 9.16667 13.225 9.16667 13.3333C9.16667 13.4417 9.19167 13.55 9.23334 13.65C9.27501 13.7583 9.33334 13.8416 9.40834 13.925C9.49167 14 9.58334 14.0583 9.68334 14.1C9.78334 14.1417 9.89167 14.1667 10 14.1667C10.1083 14.1667 10.2167 14.1417 10.3167 14.1C10.4167 14.0583 10.5083 14 10.5917 13.925C10.6667 13.8416 10.725 13.7583 10.7667 13.65C10.8083 13.55 10.8333 13.4417 10.8333 13.3333C10.8333 13.225 10.8083 13.1167 10.7667 13.0167Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.71d14c1890800a05e8ef28d538124fd2.svg";
export { ForwardRef as ReactComponent };